import React, { useEffect, useState } from 'react';
import axios from 'axios';
import api from '../api/api';

interface DeliveryConfiguration {
  operatingGroupId: number;
  configurationMode: 'protected-local-store';
  modules: { moduleId: string; telegramReady: boolean; viberReady: boolean }[];
  message: string;
}

const labels: Record<string, string> = {
  Dishes: 'Страви',
  SemiFinishedProducts: 'Напівфабрикати',
  EventOrders: 'Замовлення подій',
};

const RestaurantNotificationStatus: React.FC = () => {
  const [configuration, setConfiguration] = useState<DeliveryConfiguration | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    api.get<DeliveryConfiguration>('/notifications/delivery-configuration', { signal: controller.signal })
      .then(({ data }) => setConfiguration(data))
      .catch((reason: unknown) => {
        if (controller.signal.aborted) return;
        const message = axios.isAxiosError<{ message?: string }>(reason) ? reason.response?.data?.message : null;
        setError(message || 'Не вдалося перевірити маршрути сповіщень ресторану.');
      });
    return () => controller.abort();
  }, []);

  return <div>
    <h3>Сповіщення ресторану</h3>
    <p>Глобальні чати не використовуються для бізнес-повідомлень. Новий ресторан без власних маршрутів нічого не надсилає назовні.</p>
    <p>Це лише перегляд готовності маршрутів поточного ресторану. Токени та одержувачів у вкладці змінює системний адміністратор.</p>
    {error && <p role="alert">{error}</p>}
    {!configuration && !error && <p role="status">Завантаження стану маршрутів…</p>}
    {configuration && <div aria-label="Стан маршрутів ресторану">
      <p>Ресторан #{configuration.operatingGroupId}</p>
      {configuration.modules.map(module => <p key={module.moduleId}>
        <strong>{labels[module.moduleId] || module.moduleId}</strong>: Telegram — {module.telegramReady ? 'маршрут активний' : 'доставку не налаштовано'};
        {' '}Viber — {module.viberReady ? 'маршрут активний' : 'доставку не налаштовано'}.
      </p>)}
      <p>{configuration.message}</p>
    </div>}
  </div>;
};

export default RestaurantNotificationStatus;
